module.exports = "<ng-transclude class=\"<%= gwSummaryInfoRow %>\"></ng-transclude>"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./common/js/src/edge/platform/widgets/tiles/tileLayout/SummaryRow/tile-summary-row.html
// module id = 603
// module chunks = 0